<template>
  <SCAButton
    :as="as"
    :class="[
      $style.button,
      {
        [$style.typeBare]: type === 'bare',
        [$style.xsmall]: size === 'xsmall',
        [$style.sizeSmall]: size === 'small',
        [$style.sizeMedium]: size === 'medium',
        [$style.sizeLarge]: size === 'large',

        [$style.dropDown]: hasDropdown,
      },
    ]"
    :icon-left="icon"
    :icon-size="iconSize"
    :icon-mirror-x="iconMirrorX"
    :icon-mirror-y="iconMirrorY"
    :type="type"
    :size="size"
    :disabled="disabled"
    :has-dropdown="hasDropdown"
    :intent="intent"
    :selected="selected"
    :appearance="appearance"
  >
  </SCAButton>
</template>

<script setup lang="ts">
import type { Component } from "vue";

import type { IconName } from "./icons/iconNames.generated";
import SCAButton from "./SCAButton.vue";
import type { ButtonAppearance, ButtonSize, ButtonType, Intent } from "./types";

withDefaults(
  defineProps<{
    type?: ButtonType;
    size?: ButtonSize;
    icon?: IconName;
    iconSize?: string;
    iconMirrorX?: boolean;
    iconMirrorY?: boolean;
    disabled?: boolean;
    hasDropdown?: boolean;
    intent?: Intent;
    loading?: boolean;
    selected?: boolean;
    appearance?: ButtonAppearance;
    as?: string | Component;
  }>(),
  {
    type: "default",
    size: "medium",
    icon: undefined,
    iconSize: undefined,
    disabled: false,
    hasDropdown: false,
    intent: "none",
    loading: false,
    selected: false,
    appearance: "primary",
    iconMirrorX: false,
    iconMirrorY: false,
    as: "button",
  },
);
</script>

<style lang="scss" module>
@use "../styles/generated/figma_typo_mixins.scss" as FigmaTypoMixins;

.button {
  border-radius: var(--border-radius-large);
  gap: var(--space-component-gap-xSmall);
  &:not(.typeBare) {
    &.xsmall {
      padding: unset;
      height: var(--dimension-350);
      width: var(--dimension-350);
      &.dropDown {
        width: var(--size-xLarge);
      }
    }
    &.sizeSmall {
      padding: unset;
      height: var(--dimension-350);
      width: var(--dimension-350);
      &.dropDown {
        width: var(--size-xLarge);
      }
    }
    &.sizeMedium {
      padding: unset;
      height: var(--size-medium);
      width: var(--size-medium);
      &.dropDown {
        width: var(--size-2xLarge);
      }
    }
    &.sizeLarge {
      padding: unset;
      height: var(--size-large);
      width: var(--size-large);
      &.dropDown {
        width: var(--size-3xLarge);
      }
    }
  }
  &.typeBare {
    height: min-content !important;
  }
}
</style>
